module.exports = __webpack_public_path__ + "img/je_logo.8a89f38f.png";